/* eslint-disable no-var */

function featureCheck() {
  var isIE = false || !!document.documentMode;
  var supportsCssGrid = CSS.supports("display: grid");
  var supportsIntersectionObserver = typeof window.IntersectionObserver !== "undefined";
  var supportsResizeObserver = typeof window.ResizeObserver !== "undefined";

  if (isIE || !supportsCssGrid || !supportsIntersectionObserver || !supportsResizeObserver) {
    document.documentElement.classList.add("no-feature-support");
  }
}

if (typeof window !== "undefined") {
  featureCheck();
}
